import Config from "../config.json";

export const homePageApi = (id) =>
  Config.apiUrl + "/admin/get-available-station/" + id;
export const companyDetailsApi = (id) =>
  Config.apiUrl + "/admin/get-company-details/" + id;
